/* eslint-disable react-hooks/exhaustive-deps */
import React, { Suspense, lazy, useState, useEffect } from 'react';
import { Route, withRouter, Switch, useHistory } from 'react-router-dom';
import axios from 'axios';
import Loading from '../../Components/Commons/LoadingPage';

import { BASE_URL } from '../../constants';
import { GrantsContext } from '../../Utils/useMyGrants';

// Internal Routs
const Landing = lazy(() => import('./Landing'));
const Drawer = lazy(() => import('../../Components/Drawer'));

const Routs = withRouter(({ location }) => {
  const history = useHistory();
  const [isSecure, setIsSecure] = useState(false);
  const { reload } = React.useContext(GrantsContext);

  const cleanLocalStorage = () => {
    setIsSecure(false);
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    history.push('/');
  };

  const checkUserAndToken = async () => {
    const user = localStorage.getItem('user');
    const token = localStorage.getItem('token');

    if (user && token) {
      try {
        await axios.get(`${BASE_URL}/v2/service-order/validate-session`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-type': 'application/json; charset=UTF-8',
          },
        });
        reload();
        setIsSecure(true);
      } catch (error) {
        console.log('este es un error', error);
        cleanLocalStorage();
      }
    } else {
      cleanLocalStorage();
    }
  };

  useEffect(() => {
    checkUserAndToken();
  }, [location.pathname]);

  return (
    <Suspense fallback={<Loading />}>
      <Switch location={location}>
        {isSecure ? (
          <>
            <Route path="/" exact component={Drawer} />
            <Route path="/:suhDude+" component={Drawer} />
          </>
        ) : (
          <Route exact path="/" component={Landing} />
        )}
      </Switch>
    </Suspense>
  );
});
export default Routs;
